// Currency -> representative flag emoji, generated from an ISO country code so
// there are no hand-typed emoji to drift. Covers the wallet/base currencies and
// every destination currency ARMF delivers to. EUR maps to the EU flag.

const CURRENCY_ISO = {
  // Base / major wallet currencies
  AUD: "AU", USD: "US", EUR: "EU", GBP: "GB", NZD: "NZ", CAD: "CA",
  JPY: "JP", CNY: "CN", CHF: "CH", HKD: "HK",
  // Destination currencies
  AED: "AE", BDT: "BD", BHD: "BH", EGP: "EG", ETB: "ET", GHS: "GH",
  IDR: "ID", INR: "IN", JOD: "JO", KES: "KE", KWD: "KW", LKR: "LK",
  LSL: "LS", MAD: "MA", MGA: "MG", MYR: "MY", MZN: "MZ", NGN: "NG",
  NPR: "NP", OMR: "OM", PHP: "PH", PKR: "PK", QAR: "QA", RWF: "RW",
  SAR: "SA", SGD: "SG", SLE: "SL", THB: "TH", TND: "TN", TRY: "TR",
  TZS: "TZ", UGX: "UG", VND: "VN", XAF: "CM", XOF: "SN",
};

const flagFromIso = (iso) =>
  String.fromCodePoint(
    ...iso
      .toUpperCase()
      .split("")
      .map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65)
  );

export const flagForCurrency = (code) => {
  const iso = CURRENCY_ISO[String(code || "").toUpperCase()];
  return iso ? flagFromIso(iso) : "";
};

// "flag CODE" with a leading space trimmed when there is no flag.
export const labelWithFlag = (code) => {
  const flag = flagForCurrency(code);
  return flag ? `${flag} ${code}` : String(code || "");
};
